import React from 'react'
import MaterialSymbol from '../material-symbol'

const Contactless = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="contactless" {...props} />
))

Contactless.displayName = 'Contactless'

export default Contactless
